import { Base } from './base.model';

export class UserRoleType extends Base {
  public name: string;
}
